/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CloudAccountDetail {
    getFixupPrototypeFunction() { return CloudAccountDetail.fixupPrototype; }

    static newInstance(model: Partial<CloudAccountDetail>): CloudAccountDetail {
        let obj = Object.assign(new CloudAccountDetail(), model);
        CloudAccountDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CloudAccountDetail>): CloudAccountDetail {
        if (!model) return null;
        return CloudAccountDetail.newInstance(<CloudAccountDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CloudAccountDetail) {
        if (!obj) return;

        models.CloudAccountDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CloudAccountDetail): boolean {
        Object.setPrototypeOf(obj, CloudAccountDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Cloud account name
     */
    name: string;

    /**
     * Cloud Account ID
     */
    id: string;

    /**
     * Preferred regions of AWS
     */
    preferred_regions: Array<string>;

}
